/* Instruction manuals page (sections/product-manuals.liquid).
   Three views over server-rendered lists:
   - grid:     category cards only (default)
   - category: one list, picked by the URL hash (#phone-mounts); the header turns
               into a bar (back link left, search right) over the category name
   - search:   every row that matches the query, grouped by category
   ?product=<handle> (from the product page button) opens that product's row,
   or explains the manual isn't online yet. */
(() => {
  const root = document.querySelector('[data-tt-manuals]');
  if (!root) return;

  const input = root.querySelector('[data-manuals-search]');
  const status = root.querySelector('[data-manuals-status]');
  const empty = root.querySelector('[data-manuals-empty]');
  const back = root.querySelector('[data-manuals-back]');
  const notice = root.querySelector('[data-manuals-notice]');
  const noticeText = root.querySelector('[data-manuals-notice-text]');
  const browseTitle = root.querySelector('[data-manuals-browse-title]');
  const groups = Array.from(root.querySelectorAll('.tt-manuals__group'));
  const rows = Array.from(root.querySelectorAll('.tt-manuals__row'));

  root.classList.add('is-ready');

  const plural = (n) => `${n} ${n === 1 ? 'manual' : 'manuals'}`;
  // Match on letters and digits only, so "tt pb mesa", "TT-PB-MESA" and "ttpbmesa" all hit.
  const squash = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '');
  rows.forEach((row) => {
    row.dataset.squashed = squash(row.dataset.search || '');
  });

  function clearHighlight() {
    rows.forEach((row) => row.classList.remove('is-highlighted'));
  }

  function showGrid() {
    root.classList.remove('is-browsing', 'is-searching', 'has-bar');
    browseTitle.textContent = '';
    groups.forEach((g) => g.classList.remove('is-active'));
    rows.forEach((r) => r.classList.remove('is-filtered'));
    back.hidden = true;
    empty.hidden = true;
    status.textContent = '';
  }

  function showCategory(slug) {
    const group = groups.find((g) => g.dataset.category === slug);
    if (!group) return showGrid();
    root.classList.add('is-browsing', 'has-bar');
    root.classList.remove('is-searching');
    browseTitle.textContent = group.querySelector('.tt-manuals__group-title').textContent.trim();
    groups.forEach((g) => g.classList.toggle('is-active', g === group));
    rows.forEach((r) => r.classList.remove('is-filtered'));
    back.hidden = false;
    empty.hidden = true;
    status.textContent = '';
    return group;
  }

  function search(query) {
    const terms = query.trim().toLowerCase().split(/\s+/).map(squash).filter(Boolean);
    if (!terms.length) {
      const slug = location.hash.slice(1);
      return slug ? showCategory(slug) : showGrid();
    }
    // From a category the bar stays put; from the landing grid the centered header
    // stays, so the box the shopper is typing in doesn't jump to the corner.
    root.classList.add('is-browsing', 'is-searching');
    browseTitle.textContent = 'Search Results';
    back.hidden = !root.classList.contains('has-bar');
    let total = 0;
    groups.forEach((group) => {
      let hits = 0;
      group.querySelectorAll('.tt-manuals__row').forEach((row) => {
        const match = terms.every((t) => row.dataset.squashed.includes(t));
        row.classList.toggle('is-filtered', !match);
        if (match) hits += 1;
      });
      group.classList.toggle('is-active', hits > 0);
      total += hits;
    });
    empty.hidden = total > 0;
    status.textContent = total ? `${plural(total)} found` : '';
  }

  function fromHash() {
    input.value = '';
    clearHighlight();
    const slug = location.hash.slice(1);
    if (slug) {
      const group = showCategory(slug);
      if (group) root.scrollIntoView({ block: 'start' });
    } else {
      showGrid();
    }
  }

  let debounce;
  input.addEventListener('input', () => {
    clearTimeout(debounce);
    debounce = setTimeout(() => {
      clearHighlight();
      notice.hidden = true;
      search(input.value);
    }, 120);
  });
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      input.value = '';
      search('');
    }
  });

  back.addEventListener('click', () => {
    input.value = '';
    clearHighlight();
    notice.hidden = true;
    if (location.hash) {
      history.pushState(null, '', location.href.split('#')[0]);
    }
    showGrid();
    root.scrollIntoView({ block: 'start' });
  });

  window.addEventListener('hashchange', fromHash);

  // Arrival from a product page.
  const handle = new URLSearchParams(location.search).get('product');
  if (handle) {
    const row = rows.find((r) => r.dataset.handle === handle);
    if (row) {
      const group = row.closest('.tt-manuals__group');
      showCategory(group.dataset.category);
      row.classList.add('is-highlighted');
      // Again on load, in case fonts or header images moved things after the first pass.
      row.scrollIntoView({ block: 'center' });
      window.addEventListener('load', () => row.scrollIntoView({ block: 'center' }), { once: true });
      return;
    }
    showGrid();
    notice.hidden = false;
    fetch(`${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}.js`)
      .then((r) => (r.ok ? r.json() : null))
      .then((p) => {
        if (p && p.title) {
          noticeText.textContent = `The manual for the ${p.title} isn't online yet.`;
        }
      })
      .catch(() => {});
    return;
  }

  fromHash();
})();
